export default __webpack_public_path__ + "static/media/task.075ae6fc.svg";